import React from "react";

import Default from "src/static/tutorial/loteria-popular/default";
import SantoAmaro from "src/static/tutorial/loteria-popular/santoamaro";
import MixBet from "src/static/tutorial/loteria-popular/mixbet";

export function getTutorialLotPop() {
  const params = new URLSearchParams(window.location.search);
  // Parametros informados pelo iframe-wrappera
  let CID = params.get("CID");
  let clientId = params.get("clientId");

  if (CID) {
    switch (CID) {
      case "07F8B8DB-8BDA-4983-A9B6-14A70B7DCAF6":  //mixbet
        return <MixBet  />;
      case "DC082A75-5691-4B9E-AD41-8A890E60DFDC":  //Santo Amaro
        return <SantoAmaro />;
      case "FD5D0895-7AF8-48C3-AB33-62E9B9DF0C9D":  //petbet
      case "440854DA-10FA-41FA-8740-3B14FA36B5E3":  //abcloterias
      case "C798BBB2-0C32-440B-BBF9-5F225C6B30DF":  //akyloteriasonline
      default:
        return <Default />;
    }
  } else if (clientId) {
    switch (clientId) {
      case "2468":                                  //mixbet
        return <MixBet  />;
      case "281":                                   //Santo Amaro
        return <SantoAmaro />;
      case "3107":                                  //DEV - BS3
      default:
        return <Default />;
    }
  } else {
    return <Default />;
  }
}



// WEBPACK FOOTER //
// ./src/static/tutorial/helper/index.jsx